import { flow, types } from 'mobx-state-tree';
//@ts-ignore
import packageJson from '../../package.json';
import { getEnvironment } from './utils/utils';

export const ApplicationStore = types
  .model('ApplicationStore', {
    appVersion: packageJson.version,
    mailRedirection: types.maybe(types.string),
    database: types.maybe(types.string),
    transferModuleMode: types.maybe(types.string)
  })
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const navigate = (url: string, state?: any) => {
      env.history.push(url);
    };

    const replace = (url: string, state?: any) => {
      env.history.replace(url);
    };

    const getMailRedirection = flow(function*() {
      const result = yield apiFetcher.get('system/mailRedirection');
      self.mailRedirection = result;
    });

    const getDatabase = flow(function*() {
      const result = yield apiFetcher.get('system/database');
      self.database = result;
    });

    const getTransferModuleMode = flow(function*() {
      const result = yield apiFetcher.get('system/transferModuleMode');
      self.transferModuleMode = result;
      return result;
    });

    return {
      navigate,
      replace,
      getMailRedirection,
      getDatabase,
      getTransferModuleMode,
      afterAttach: flow(function*() {
        yield getMailRedirection();
      }),
    };
  });
